import { PageSection } from '@gik/ui/gik/PageSection';
import React from 'react';
import bemBlock from '../utils/bemBlock';
import { SitemapSectionView } from './SitemapSectionView';

import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { ErrorPageSection } from './Error/ErrorPageSection';
import { useEnvStore } from '../store/EnvStore';

function SitemapComp() {
  const bem = bemBlock('sitemap');
  const frontendBaseUrl = useEnvStore.getState().FRONTEND_BASE_URL || '/';

  const prefixes = {
    static: '',
  };

  const staticPages = [
    { url: 'terms-service', title: 'Terms of Service' },
    { url: 'privacy-policy', title: 'Privacy Policy' },
    { url: 'create', title: 'Create' },
    { url: 'how-inkind-works', title: 'How InKind Works' },
    { url: 'features', title: 'Features' },
    { url: 'competitors', title: 'Competitors' },
    { url: 'faq', title: 'FAQ' },
    { url: 'about-us', title: 'About Us' },
    { url: 'contact', title: 'Contact' },
    { url: 'donate-gift-cards', title: 'Donate Gift Cards' },
    { url: 'set-up-meal-train', title: 'Set Up Meal Train' },
    { url: 'tips-sample-pages', title: 'Tips Sample Pages' },
    { url: 'share-updates', title: 'Share Updates' },
    { url: 'organize-gift-card-drive', title: 'Organize Gift Card Drive' },
    { url: 'organize-care-group', title: 'Organize Care Group' },
    { url: 'free-fundraising', title: 'Free Fundraising' },
    { url: 'organize-donation-drive', title: 'Organize Donation Drive' },
    { url: 'give', title: 'Give' },
  ];

  return (
    <PageSection className={bem()}>
      <div className="tw-flex tw-flex-wrap">
        <SitemapSectionView
          baseUrl={frontendBaseUrl}
          title="Static Pages"
          items={staticPages}
          prefix={prefixes.static}
        />
      </div>
      <div>
        <h2>Other Sitemap Sections</h2>
        <a href={`${frontendBaseUrl}products/sitemap`}>Products</a>
        <br />
        <a href={`${frontendBaseUrl}inkinds/sitemap`}>Give InKind Pages</a>
        <br />
        <a href={`${frontendBaseUrl}give/sitemap`}>Give By</a>
        <br />
        <a href={`${frontendBaseUrl}articles/sitemap`}>Articles</a>
        <br />
      </div>
    </PageSection>
  );
}

export const SitemapPage = withComponentErrorBoundary(SitemapComp, { ErrorFallback: ErrorPageSection });
